import 'unfetch/polyfill/index.js';
import i18n from 'i18next';
import Fetch from 'i18next-fetch-backend';
import { getSearchParams } from '@/shared/utils/get-search-params';
import { searchParamsBuilder } from '@/shared/utils/search-params-builder';

const nameSpaces = [ 'common', 'payment', 'shoppingcart' ].join();
const { marketId, lang: lng } = getSearchParams();
const searchString = searchParamsBuilder({ nameSpaces, marketId });
const loadPath = `${ document.body.dataset.contextPath || '' }/messages?lang={{lng}}&${ searchString }`;

i18n.use(Fetch)
    .init({
        lng,
        fallbackLng : lng,
        keySeparator: false,
        backend     : { loadPath },
        react       : { useSuspense: true },
    });

export default i18n;
